module.exports = __webpack_public_path__ + "images/wxwork/img-wcwf-1@2x-5a202fd5cd3d64f0081d9f58e9533685.png";